import { API_ROUTES } from '@config/routes';
import api from './api';

export interface TeamMember {
  id: string;
  ownerId: string;
  memberId: string | null;
  email: string;
  displayName: string;
  status: 'active' | 'invited';
  invitedAt: string;
  joinedAt: string | null;
}

export const teamService = {
  getMembers: (): Promise<TeamMember[]> => api.get<TeamMember[]>(API_ROUTES.TEAM.MEMBERS),
  inviteMember: (email: string): Promise<TeamMember> =>
    api.post<TeamMember>(API_ROUTES.TEAM.MEMBERS, { email }),
  removeMember: (membershipId: string): Promise<void> =>
    api.delete<void>(API_ROUTES.TEAM.MEMBER_BY_ID(membershipId)),
  claimInvitations: (token?: string): Promise<TeamMember[]> =>
    api.post<TeamMember[]>(API_ROUTES.TEAM.CLAIM_INVITATIONS, { token }),
};
